import React, { FC, useState } from 'react';
import { PersonType } from '../types';
import covers from '../data/covers';
import { ageToGroup } from '../utils';
import ContactForm from './ContactForm';

import {
  faPlus,
  faMinus,
  faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Stage3Props = {
  persons: PersonType[];
  onPersonChange: (person: PersonType[]) => void;
  onQuestionClick: (index: number) => void;
};
const Stage3: FC<Stage3Props> = ({
  persons,
  onPersonChange,
  onQuestionClick: handleCoverQuestionClick,
}) => {
  const handleCoverClick = (person: PersonType, coverIndex: number) => {
    const index = persons.findIndex(({ id }) => id === person.id);
    person.covers[coverIndex] = !person.covers[coverIndex];
    const newPersons = [
      ...persons.slice(0, index),
      { ...person, covers: [...person.covers] },
      ...persons.slice(index + 1),
    ];
    onPersonChange(newPersons);
  };

  return (
    <div className="summery">
      {persons.map((person) => (
        <div key={person.id} className="summery_item">
          <span className="summery_item_name">{person.name} - </span>
          <span className="summery_item_count">
            {' '}
             ₪
            {person.covers
              .reduce(
                (sum, cover, index) =>
                  (sum += cover
                    ? covers[index].prices[ageToGroup(person.age)]
                    : 0),
                0
              )
              .toFixed(2)}{' '}
            לחודש
          </span>
        </div>
      ))}
      <div className="discount">
        <span className="discount_title">פרמיה לפני הנחה:</span>
        <span className="discount_num" style={{ background: "#e1e1e1" }}>
          {(
            persons.reduce((totalSum, person) => {
              totalSum += person.covers.reduce(
                (sum, cover, index) =>
                  (sum += cover
                    ? covers[index].prices[ageToGroup(person.age)]
                    : 0),
                0
              );
              return totalSum;
            }, 0)
          ).toFixed(2)}{' '}
          ₪ לחודש
        </span>
        <span className="discount_title">פרמיה לאחר הנחה:</span>
        <span className="discount_num">
          {(
            persons.reduce((totalSum, person) => {
              totalSum += person.covers.reduce(
                (sum, cover, index) =>
                  (sum += cover
                    ? covers[index].prices[ageToGroup(person.age)]
                    : 0),
                0
              );
              return totalSum;
            }, 0) * 0.8
          ).toFixed(2)}{' '}
          ₪ לחודש
        </span>
      </div>

      <ContactForm persons={persons} />
    </div>
    /*
    <div
      className={`grid grid-cols-${persons.length + 1} grid-flow-row m-2 gap-2`}
    >
      <div></div>
      {persons.map((person) => (
        <div key={person.id} className="font-bold text-2xl text-center">
          {person.name}{' '}
          <span className="text-sm text-gray-800 font-bold">{person.age}</span>
        </div>
      ))}

      {covers.map((cover, index) => (
        <React.Fragment key={index}>
          <div
            key={index}
            className="font-bold truncate"
            onClick={() => handleCoverQuestionClick(index)}
          >
            {index + 1}. {cover.title}{' '}
          </div>

          {persons.map((person) => (
            <div
              key={person.id}
              className="px-2 cursor-pointer border-2"
              style={{
                backgroundColor: person.covers[index] ? '#FCB831' : '#fff',
              }}
              onClick={() => handleCoverClick(person, index)}
            >
              {`עד ₪${covers[index].prices[ageToGroup(person.age)]} לחודש`}
              <div className="float-left">
                <FontAwesomeIcon
                  icon={person.covers[index] ? faMinus : faPlus}
                  size="sm"
                  color={person.covers[index] ? '#000' : '#FCB831'}
                />
              </div>
            </div>
          ))}
        </React.Fragment>
      ))}

      <div>
        <span className="text-2xl font-bold ">סה״כ</span>
      </div>

      {persons.map((person) => (
        <div
          key={person.id}
          className="text-2xl font-bold text-center  border-2 "
        >
          {' '}
          עד ₪
          {person.covers
            .reduce(
              (sum, cover, index) =>
                (sum += cover
                  ? covers[index].prices[ageToGroup(person.age)]
                  : 0),
              0
            )
            .toFixed(2)}{' '}
          לחודש
        </div>
      ))}
    </div>
    */
  );
};

export default Stage3;
